import InnerComponent from '@Components/Purchase/PurchaseOrders/POForm';
import orgContainer from '@Components/AppContainer';

const UpdatePurchaseOrder = () => ((orgContainer(InnerComponent)));
export default UpdatePurchaseOrder;
